var map = {
	"./cards/ranks/black/ace.svg": 884,
	"./cards/ranks/black/eight.svg": 885,
	"./cards/ranks/black/five.svg": 886,
	"./cards/ranks/black/four.svg": 887,
	"./cards/ranks/black/jack.svg": 888,
	"./cards/ranks/black/king.svg": 889,
	"./cards/ranks/black/nine.svg": 890,
	"./cards/ranks/black/queen.svg": 891,
	"./cards/ranks/black/seven.svg": 892,
	"./cards/ranks/black/six.svg": 893,
	"./cards/ranks/black/ten.svg": 894,
	"./cards/ranks/black/three.svg": 895,
	"./cards/ranks/black/two.svg": 896,
	"./cards/ranks/red/ace.svg": 897,
	"./cards/ranks/red/eight.svg": 898,
	"./cards/ranks/red/five.svg": 899,
	"./cards/ranks/red/four.svg": 900,
	"./cards/ranks/red/jack.svg": 901,
	"./cards/ranks/red/king.svg": 902,
	"./cards/ranks/red/nine.svg": 903,
	"./cards/ranks/red/queen.svg": 904,
	"./cards/ranks/red/seven.svg": 905,
	"./cards/ranks/red/six.svg": 906,
	"./cards/ranks/red/ten.svg": 907,
	"./cards/ranks/red/three.svg": 908,
	"./cards/ranks/red/two.svg": 909,
	"./cards/shirt.png": 910,
	"./cards/shirt.svg": 911,
	"./cards/suits/club.svg": 912,
	"./cards/suits/diamond.svg": 913,
	"./cards/suits/heart.svg": 914,
	"./cards/suits/spade.svg": 915,
	"./caret-down.svg": 916,
	"./caret-left.svg": 917,
	"./caret-right.svg": 918,
	"./logoSpade.svg": 919,
	"./logoTableSpade.svg": 920,
	"./personBlack.svg": 921,
	"./personGrow.svg": 922,
	"./personWhite.svg": 923,
	"./poc-logoTableSpade.svg": 924,
	"./poc-pokerlistings.svg": 925,
	"./poc-table-logo.svg": 926,
	"./poc-table.png": 927,
	"./pokerlistings.svg": 928,
	"./pokerlistingscomlogo.svg": 186,
	"./questionMark.svg": 929,
	"./table2.png": 930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 883;